export { default as Img200 } from './processed/200/Pompeii.jpg';
export { default as Img400 } from './processed/400/Pompeii.jpg';
export { default as Imgthumb } from './processed/thumb/Pompeii.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Pompeii.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Pompeii.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      213,
      113,
      49
    ],
    "_population": 231,
    "_hsl": [
      0.06504065040650406,
      0.6612903225806452,
      0.5137254901960785
    ]
  },
  "LightVibrant": {
    "_rgb": [
      250,
      237,
      154
    ],
    "_population": 1638,
    "_hsl": [
      0.14409722222222224,
      0.9056603773584906,
      0.792156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      133,
      52,
      32
    ],
    "_population": 26,
    "_hsl": [
      0.033003300330033,
      0.6121212121212122,
      0.3235294117647059
    ]
  },
  "Muted": {
    "_rgb": [
      158,
      117,
      86
    ],
    "_population": 261,
    "_hsl": [
      0.07175925925925923,
      0.29508196721311475,
      0.47843137254901963
    ]
  },
  "LightMuted": {
    "_rgb": [
      216,
      197,
      165
    ],
    "_population": 496,
    "_hsl": [
      0.10457516339869283,
      0.39534883720930236,
      0.7470588235294118
    ]
  },
  "DarkMuted": {
    "_rgb": [
      74,
      46,
      49
    ],
    "_population": 1603,
    "_hsl": [
      0.9821428571428571,
      0.2333333333333334,
      0.23529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Pompeii.js